export default function extractExpiryDateData({
  date,
  locale,
}: {
  date: string;
  locale: string;
}) {
  const expiryDate = date.split('/').map(Number);
  const month = locale ? expiryDate[0] : expiryDate[1];
  const year = locale ? expiryDate[1] : expiryDate[0];
  return { month, year };
}
